module.exports = __webpack_public_path__ + "static/media/pdf-icon.b648cd05.svg";